"use client";

import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";
import "./TopCourseCategories.css";

const courseCategories = [
  {
    id: 1,
    title: "Online MBA",
    image:
      "/assets/images/home/TopCourseCategories/Online-MBA.jpg",
  },
  {
    id: 2,
    title: "Executive MBA",
    image: "/assets/images/home/TopCourseCategories/Executive-MBA.jpg",
  },
  {
    id: 3,
    title: "Online MCA",
    image: "/assets/images/home/TopCourseCategories/Online-MCA.jpg",
  },
  {
    id: 4,
    title: "Online BBA",
    image: "/assets/images/home/TopCourseCategories/Online-BBA.jpg",
  },
  {
    id: 5,
    title: "Online BCA",
    image: "/assets/images/home/TopCourseCategories/Online-BCA.jpg",
  },
  {
    id: 6,
    title: "Online B.com",
    image: "/assets/images/home/TopCourseCategories/Online-B.com.jpg",
  },
  {
    id: 7,
    title: "PGDM",
    image: "/assets/images/home/TopCourseCategories/PGDM.jpg",
  },
  {
    id: 8,
    title: "Certification",
    image: "/assets/images/home/TopCourseCategories/certification.jpg",
  },
];

const TopCourseCategories = () => {
  return (
    <section className="TopCourseCategories common_div">
      <div className="container">
        {/* <div className="section_heading">
          <h2>Top Course Categories</h2>
        </div> */}

        <Main_heading_holder
          heading="Top "
          spanHeading="Course Categories  "
        //   subHeading=" Our online MBA specialisations are crafted with industry leaders to match evolving business demands."
          headingType="h2"
        />

        <div className="row g-4">
          {courseCategories.map((item) => (
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6" key={item.id}>
              <div className="category_card">
                <img src={item.image} alt={item.title} />

                {/* <div className="image_overlay"></div> */}

                <div className="category_title">
                  <h3>{item.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopCourseCategories;
